import { useEffect, useState } from "react";
import { punchOutbox } from "@/offline/punchOutbox";
import type { QueuedPunch } from "@/offline/outboxStore";

/**
 * Live view of the on-device punch queue — mirrors `hooks/useOutbox.ts` exactly (same
 * "read-only subscription onto a singleton" shape). Components enqueue through
 * `punchOutbox.enqueue`, never through local state, so there is exactly one source of
 * truth for what is pending.
 */
export function usePunchOutbox(): QueuedPunch[] {
  const [items, setItems] = useState<QueuedPunch[]>([]);

  useEffect(() => {
    let cancelled = false;
    punchOutbox.list().then((list) => {
      if (!cancelled) setItems(list);
    });
    const unsubscribe = punchOutbox.subscribe((list) => {
      if (!cancelled) setItems(list);
    });
    return () => {
      cancelled = true;
      unsubscribe();
    };
  }, []);

  return items;
}
